module.exports = __webpack_public_path__ + "static/img/Seminar.a8fe378.png";